import Landing from '../modules/entry';
import withViewEvent from '../modules/common/utils/tracking/withViewEvent';
import { K_AMPLITUDE_EVENT_VIEW_HOME_PAGE } from '../modules/common/libs/amplitude/events';

export default withViewEvent(Landing, K_AMPLITUDE_EVENT_VIEW_HOME_PAGE);
